import { render, staticRenderFns } from "./payFee.vue?vue&type=template&id=7472ce4f&scoped=true&"
import script from "./payFee.vue?vue&type=script&lang=js&"
export * from "./payFee.vue?vue&type=script&lang=js&"
import style0 from "./payFee.vue?vue&type=style&index=0&id=7472ce4f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7472ce4f",
  null
  
)

export default component.exports